import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";

import { AddProfessionalReviewCandidate } from "../../../types/addReviewCandidate";

import RatingTable from "../RatingTable";

const ProfessionalExpertiseStep = () => {
  const { t } = useTranslation("goHire", { keyPrefix: "components.reviewCandidateModal" });
  const { t: tProfReport } = useTranslation("goHire", {
    keyPrefix: "components.reviewCandidateModal.professionalReport",
  });

  const { control } = useFormContext<AddProfessionalReviewCandidate>();

  const skills: { title: string; description: string; fieldName: keyof AddProfessionalReviewCandidate }[] = [
    {
      title: tProfReport("domainKnowledge"),
      description: tProfReport("depthOfTechnicalTacticalKnowledge"),
      fieldName: "domainKnowledge",
    },
    {
      title: tProfReport("trackRecordAchievements"),
      description: tProfReport("pastExperienceResults"),
      fieldName: "trackRecordAchievements",
    },
    {
      title: tProfReport("analyticalSkills"),
      description: tProfReport("abilityToAnalyze"),
      fieldName: "analyticalSkills",
    },
    {
      title: tProfReport("talentIdentification"),
      description: tProfReport("abilityToSpotEvaluateNurture"),
      fieldName: "talentIdentification",
    },
    {
      title: tProfReport("innovationMethods"),
      description: tProfReport("creativityInApplyingModernApproaches"),
      fieldName: "innovationMethods",
    },
  ];

  return (
    <Box sx={[styles.container, styles.containerPadding]}>
      <RatingTable ratings={skills} control={control} />
    </Box>
  );
};

export default ProfessionalExpertiseStep;

const styles = {
  containerPadding: {
    px: "24px",
  },
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
};
